import i18n from '../i18n';

/**
 * Get current language from i18next (from cookie or fallback to 'en')
 * @returns {string} Current language code (e.g., 'en', 'es', 'zh', 'ko')
 */
export const fGetCurrentLanguage = () => {
  try {
    return i18n.language || 'en';
  } catch (error) {
    console.warn('Failed to get language from i18next, defaulting to "en":', error);
    return 'en';
  }
};